import React from 'react';
import { Loading } from 'components/Loading';
import { Icon } from 'components/Icon';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useLienLaws } from 'components/LienLaws/hooks/useLienLaws';
import './styles.scss';

interface LienLaw {
    id: string
    state_id: string
    link: string
    created_at: string
    modified: string
    state_name: string
    iso_numeric: string
    country_id: string
}

interface LienLawsProps {
    country_id: number
}

export const LienLaws = (props: LienLawsProps) => {
    const { lienLaws, headings, loading } = useLienLaws({
        country_id: props.country_id,
    });

    return (
        <div className="lien-laws__container">
            <h2>United States</h2>

            {loading && <Loading />}

            {!!lienLaws?.length && (
                <div className="lien-laws__grid">
                    {headings.map(
                        ({ startIndex, endIndex, startLabel, endLabel }) => (
                            <div key={startIndex}>
                                <h5 className="lien-laws__letter-range">
                                    {startLabel} - {endLabel}
                                </h5>

                                <div className="lien-laws__state-container">
                                    {lienLaws
                                        .slice(startIndex, endIndex + 1)
                                        .map((law: LienLaw) => (
                                            <a
                                                key={law.id}
                                                href={law.link}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="lien-laws__state"
                                            >
                                                <span className="state-name">
                                                    {law.state_name}
                                                </span>
                                                <Icon
                                                    className="icon"
                                                    size="xl"
                                                    icon={faArrowRight}
                                                />
                                            </a>
                                        ))}
                                </div>
                            </div>
                        ),
                    )}
                </div>
            )}
        </div>
    );
};